// bao migrate skip
import "./../../services/bao-router";
import "./../../bindings/bao-searcher";
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import BaoDialogViewModel from "./../../factories/bao-dialog";
import baoRouter from "./../../services/bao-router";
class AbsentDaysForOnePersonReportViewModel {
    constructor(parent: any) {
        this.parent = parent;
        this._initialized = false;
    }
    parent: any;
    Bao = Bao;
    private _initialized: boolean;
    ConfigurationItemId: KnockoutObservable<string> = ko.observable("");
    PersonFullName: KnockoutObservable<string> = ko.observable("");
    Years: KnockoutObservableArray<number> = ko.observableArray([]);
    SelectedYear: KnockoutObservable<number> = ko.observable(null);
    HolidayDataForPerson: KnockoutObservableArray<any> = ko.observableArray([]);
    TotalDaysForHolidayType: KnockoutObservableArray<any> = ko.observableArray([]);
    /** true if the report has loaded data, false otherwise
     */
    ReportLoaded: KnockoutObservable<boolean> = ko.observable(false);
    /** true if the report has loaded at least once
     */
    ReportRequested: KnockoutObservable<boolean> = ko.observable(false);
    /** true if the report has loaded and no data are available, false otherwise
     */
    IsReportResultEmpty: KnockoutComputed<boolean> = ko.pureComputed(() => { return (this.ReportLoaded() === false) && this.ReportRequested(); });
    Download() {
        if (this.ConfigurationItemId() == null || this.SelectedYear() == null) {
            new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        else {
            this.parent.TabPage.IsLoading(true);
            Bao.post("SynosetReportCenter/AbsentDaysForOnePersonReportDownload", JSON.stringify({
                personId: this.ConfigurationItemId(),
                year: this.SelectedYear(),
                reportTemplateId: null
            }), (result) => {
                this.parent.TabPage.IsLoading(false);
                if (result.Result == true) {
                    baoRouter.setHash("document/" + result.Message);
                }
            });
        }
    }
    GetReport() {
        if (this.ConfigurationItemId() == null || this.SelectedYear() == null) {
            new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        else {
            this.ReportLoaded(false);
            this.parent.TabPage.IsLoading(true);
            Bao.post("SynosetReportCenter/AbsentDaysForOnePersonReportGetReport", JSON.stringify({
                personId: this.ConfigurationItemId(),
                year: this.SelectedYear(),
                reportTemplateId: null
            }), (result) => {
                if (result.Result) {
                    this.HolidayDataForPerson(result.Value);
                    this.TotalDaysForHolidayType(this.calculateTotalDaysForHolidayType(result.Value));
                    this.ReportLoaded(true);
                }
                this.parent.TabPage.IsLoading(false);
                this.ReportRequested(true);
            });
        }
    }
    calculateTotalDaysForHolidayType(holidayDataForPerson: any[]): any[] {
        var totalDaysForHolidayType = new Array<any>();
        holidayDataForPerson.forEach(item => {
            var filterElement = totalDaysForHolidayType.filter(e => e.HolidayType === item.HolidayType);
            var holidayDays = parseFloat(item.HolidayDays.replace(",", "."));
            if (holidayDays || holidayDays === 0) {
                if (filterElement && filterElement.length > 0) {
                    filterElement[0].TotalDays += holidayDays;
                }
                else {
                    totalDaysForHolidayType.push({ HolidayType: item.HolidayType, TotalDays: holidayDays });
                }
            }
        });
        totalDaysForHolidayType.forEach(item => {
            item.TotalDays = item.TotalDays.toString().replace(".", ",");
        });
        return totalDaysForHolidayType;
    }
    init() {
        return Bao.post("SynosetReportCenter/AbsentDaysForOnePersonReportGetDefaultData", (result) => {
            ko.map.fromJS(result, this);
            this._initialized = true;
        });
    }
    ;
    loaded() {
        //Dashboard laden
        var currentDate = new Date();
    }
    ;
}
export default AbsentDaysForOnePersonReportViewModel;